import { IFile } from './IFile';
export class IAttachmentDocs{
    files: Array<IFile>;
    descriptionDocument;
    constructor(def:any){
        this.files = def.files || [];
        this.descriptionDocument = def.descriptionDocument || "";
    }
}